import { config } from 'app/config'
import { LocationState } from 'features/Login'
import { useShipUserPreference } from 'features/Settings'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useRootStore } from 'service/useRootStore'
import { UnleashFeatureFlagKeys, useUnleashFeatureFlags } from 'service/useUnleashFeatureFlags'
import { logError } from 'utils/logger'

import { getRedirectUrl } from './betaEnrollmentUtils'

export const useBetaEnrollment = () => {
  const { authStore } = useRootStore()
  const { isFFLoading, isEnabled } = useUnleashFeatureFlags()
  const { isShipUserPreferenceLoading, shipUserPreference, getShipUserPreference } = useShipUserPreference()
  const history = useHistory<LocationState>()
  const { location } = history

  const shouldWaitForUserPreference =
    isEnabled(UnleashFeatureFlagKeys.SHIP_V2_BETA) &&
    !isShipUserPreferenceLoading &&
    !shipUserPreference?.value.useLegacyUI

  useEffect(() => {
    if (authStore.state.token) {
      getShipUserPreference()
    }
  }, [authStore.state.token, getShipUserPreference])

  useEffect(() => {
    if (shouldWaitForUserPreference) {
      const redirectUrl = getRedirectUrl({
        currentUrl: window.location.href,
        newSystemBaseUrl: config.SHIP_V2_URL,
        locationState: location?.state,
      })

      // Guard against potential redirect loops
      if (redirectUrl !== window.location.href) {
        window.location.href = redirectUrl
      } else {
        logError('[Beta Enrollment] Prevented redirect loop')
      }
    }
  }, [shouldWaitForUserPreference])

  return {
    shouldDelayAppRendering: isFFLoading || shouldWaitForUserPreference,
  }
}
